import { appContextActions } from '@gef-ui/redux-common/constants';

import { URLS_ACTIONS } from '../constants';

export const saveUrls = (body) => ({
	type: URLS_ACTIONS.save_urls,
	payload: {
		token: body.tokenUrl,
		codelist: body.backendUrl,
		authorize: body.gatewayUrl,
		baseUrl: body.backendUrl,
	},
});

export const saveConfig = (config) => ({
	type: appContextActions.MERGE_APP_CONTEXT,
	payload: {
		backendUrl: config.backendUrl,
		gatewayUrl: config.gatewayUrl,
		clientId: config.clientId,
	},
});
